const awsConfig = {
    // identityPoolId: 'ap-south-1:62c69269-14c1-4213-9fd8-3011bcd1833c',
    // region: 'ap-south-1',
    // userPoolId: 'ap-south-1_lYRXJB955',
    // userPoolWebClientId: '2lflj5i9hesfe0cvqhofjopfpr'

//     "aws_project_region": "us-east-2",
//     "aws_cognito_identity_pool_id": "us-east-2:b0958948-9fee-4dce-9de2-fd7f03336d9e",
//     "aws_cognito_region": "us-east-2",
//    "aws_user_pools_id": "us-east-2_kItS2gWzv",
//     "aws_user_pools_web_client_id": "7dk0eveu85689tsjsvkb161kn",
//     "oauth": {},


    "aws_project_region": "us-east-2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": process.env.REACT_APP_AGENT_USER_POOL,
    "aws_user_pools_web_client_id": process.env.REACT_APP_aws_user_pools_web_client_id,
    "aws_cognito_identity_pool_id": process.env.REACT_APP_aws_cognito_identity_pool_id,
    "oauth": {},
   
//    --------------DEV
    // "aws_project_region": "us-east-2",
    // "aws_cognito_region": "us-east-2",
    // "aws_user_pools_id": "us-east-2_EHdBi4APx",
    // "aws_user_pools_web_client_id": "1klr4s32cc9k308pnb5gtd9pqj",
    // "aws_cognito_identity_pool_id": "us-east-2:6b34c4ec-6ef9-4a5d-8242-97ee1f98be7a",
    // "oauth": {},

    // -------------carynhealth
    // "aws_project_region": "us-east-2",
    // "aws_cognito_region": "us-east-2",
    // "aws_user_pools_id": "us-east-2_fIv6xnFnv",
    // "aws_user_pools_web_client_id": "39pbo8p0f1r3mh941b2lluchtm",
    // "aws_cognito_identity_pool_id": "us-east-2:86027bd4-0bb0-450c-9e6e-a1d1c5cf0f18",
    // "oauth": {},
}

export default awsConfig;